import { useMemo } from "react";
import { useLingui } from "@lingui/react";
import type { LocalizedMessage } from "../types";
import { resolveLocalizedMessage } from "../utils/resolveLocalizedMessage";

/**
 * Hook for resolving localized messages with parameter interpolation.
 * Translates resource names and main message using Lingui.
 * @param message - LocalizedMessage object with key and params
 * @returns Resolved message string with interpolated parameters
 */
export function useLocalizedSyncMessage(
  message: LocalizedMessage | null | undefined,
): string {
  const { i18n } = useLingui();

  return useMemo(() => {
    return resolveLocalizedMessage(i18n, message);
  }, [message, i18n]);
}
